import { ComponentsOverrides, Theme } from '@mui/material';

export const alertTitleTheme = {
    styleOverrides: {
        root: {
            fontSize: '1.125rem',
        },
    },
};

export const alertTheme: {
    styleOverrides: ComponentsOverrides<Theme>['MuiAlert'];
} = {
    styleOverrides: {
        root: ({ ownerState, theme: { palette } }) => ({
            backgroundColor: palette.secondary.light,
            color: palette.text.primary,
            ['& .MuiAlert-message']: {
                overflow: 'visible',
            },
            ['& .MuiButton-startIcon']: {
                marginRight: '5px',
                ['& .MuiSvgIcon-root']: {
                    fontSize: 16,
                },
            },
            ...(ownerState.size === 'large' && {
                minHeight: 100,
                ['& .MuiSvgIcon-root']: {
                    fontSize: 24,
                },
            }),
            ...(ownerState.size === 'small' && {
                ['& .MuiAlertTitle-root']: {
                    fontSize: '0.875rem',
                },
                ['& .MuiSvgIcon-root']: {
                    fontSize: 20,
                },
            }),
        }),
        standardSuccess: ({ theme: { palette } }) => ({
            backgroundColor: palette.success.light,
            color: palette.text.primary,
        }),
        standardWarning: ({ theme: { palette } }) => ({
            backgroundColor: palette.warning.light,
            color: palette.text.primary,
        }),
        standardInfo: ({ theme: { palette } }) => ({
            backgroundColor: palette.info.light,
            color: palette.text.primary,
        }),
        standardError: ({ theme: { palette } }) => ({
            backgroundColor: palette.error.light,
            color: palette.text.primary,
        }),
    },
};
